(() => {
  'use strict';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  async function ubiyamAddToCart(items) {
    const cartEl =
      document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items };
    if (cartEl && typeof cartEl.getSectionsToRender === 'function') {
      body.sections = cartEl.getSectionsToRender().map((section) => section.id);
      body.sections_url = window.location.pathname;
    }
    const response = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (data.status) throw data;
    if (cartEl && typeof cartEl.renderContents === 'function') {
      cartEl.renderContents(data);
    } else {
      window.location = window.routes.cart_url;
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'ubiyam',
        cartData: data,
      });
    }
    refreshCartCount();
    return data;
  }

  async function refreshCartCount() {
    const link = document.getElementById('cart-icon-bubble');
    if (!link) return;
    try {
      const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
      const res = await fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      const count = Number(cart.item_count) || 0;
      let bubble = link.querySelector('.cart-count-bubble');
      if (count > 0) {
        if (!bubble) {
          bubble = document.createElement('div');
          bubble.className = 'cart-count-bubble';
          link.appendChild(bubble);
        }
        const shown = count < 100 ? count : '';
        bubble.innerHTML = `<span aria-hidden="true">${shown}</span>`;
      } else if (bubble) {
        bubble.remove();
      }
    } catch (err) {

    }
  }

  function bindDrawerOnProductFormAdd() {

    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) {
      return false;
    }
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {

      if (!event || event.source !== 'product-form') return;
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        setTimeout(() => drawer.open(), 0);
      }

      refreshCartCount();
    });
    return true;
  }
  if (!bindDrawerOnProductFormAdd()) {
    document.addEventListener('DOMContentLoaded', bindDrawerOnProductFormAdd);
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;
    button.toggleAttribute('aria-disabled', isLoading);
    button.classList.toggle('is-loading', isLoading);
    if (isLoading) {
      button.dataset.ubiyamLabel = button.innerHTML;
      button.innerHTML = '<span class="ubiyam-btn__spinner" aria-hidden="true">&hellip;</span>';
    } else if (button.dataset.ubiyamLabel) {
      button.innerHTML = button.dataset.ubiyamLabel;
      delete button.dataset.ubiyamLabel;
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('form[data-ubiyam-quick-add]');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    if (button && button.hasAttribute('aria-disabled')) return;

    let items = [];
    const single = form.querySelector('input[name="id"]');
    if (single) {
      items = [{ id: Number(single.value), quantity: 1 }];
    } else {
      items = Array.from(form.querySelectorAll('input[name="items[][id]"]')).map((input) => ({
        id: Number(input.value),
        quantity: 1,
      }));
    }
    if (!items.length) return;

    setButtonLoading(button, true);
    ubiyamAddToCart(items)
      .catch((error) => {
        const message = error && error.description ? error.description : window.cartStrings.error;
        let live = form.querySelector('.ubiyam-form-error');
        if (!live) {
          live = document.createElement('p');
          live.className = 'ubiyam-form-error';
          live.setAttribute('role', 'alert');
          form.appendChild(live);
        }
        live.textContent = message;
      })
      .finally(() => setButtonLoading(button, false));
  });

  function itemFromProductForm(form) {
    const data = new FormData(form);
    const id = Number(data.get('id'));
    if (!id) return null;
    const item = { id, quantity: Number(data.get('quantity')) || 1 };
    const sellingPlan = data.get('selling_plan');
    if (sellingPlan) item.selling_plan = Number(sellingPlan);
    const properties = {};
    data.forEach((value, key) => {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) item.properties = properties;
    return item;
  }

  function setProductFormLoading(button, form, isLoading) {
    if (button) {
      button.toggleAttribute('aria-disabled', isLoading);
      button.classList.toggle('loading', isLoading);
    }
    const spinner = form.querySelector('.loading__spinner');
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.hasAttribute('data-ubiyam-quick-add')) return;
      if (!form.closest('product-form') || form.closest('quick-add-modal')) return;
      const idInput = form.querySelector('[name="id"]');
      if (!idInput || idInput.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const item = itemFromProductForm(form);
      if (!item) return;
      const button =
        form.querySelector('[type="submit"]') || form.closest('product-form').querySelector('[type="submit"]');
      if (button && button.getAttribute('aria-disabled') === 'true') return;

      const errorWrapper = form.querySelector('.product-form__error-message-wrapper');
      const errorText = form.querySelector('.product-form__error-message');
      if (errorWrapper) errorWrapper.setAttribute('hidden', '');

      setProductFormLoading(button, form, true);
      ubiyamAddToCart([item])
        .catch((error) => {
          const message = (error && error.description) || (window.cartStrings && window.cartStrings.error) || '';
          if (errorText && errorWrapper) {
            errorText.textContent = message;
            errorWrapper.removeAttribute('hidden');
          }
        })
        .finally(() => setProductFormLoading(button, form, false));
    },
    true
  );

  class UbiyamSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ubiyam-slider');
      this.prevButton = this.querySelector('[data-slider-prev]');
      this.nextButton = this.querySelector('[data-slider-next]');
      if (!this.track) return;

      this.wantsLoop = this.hasAttribute('data-loop');
      this.originals = Array.from(this.track.children);
      this.loopReady = false;
      this.sideSets = 2;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByItem(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByItem(1));

      this.dotsHost = this.hasAttribute('data-dots') ? this.querySelector('[data-slider-dots]') : null;
      this.dotCount = -1;
      if (this.dotsHost) {
        this.dotsHost.addEventListener('click', (event) => {
          const dot = event.target.closest('button[data-dot]');
          if (dot) this.scrollToStop(Number(dot.dataset.dot));
        });
      }

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.setup());
        this.ro.observe(this.track);
      } else {
        this._onResize = () => this.setup();
        window.addEventListener('resize', this._onResize, { passive: true });
      }
      this.setup();

      const autoplaySeconds = Number(this.dataset.autoplay || 0);
      if (autoplaySeconds > 0 && !reducedMotion.matches && this.originals.length > 1) {
        const advance = () => {
          if (this.loopReady) {
            this.scrollByItem(1);
            return;
          }
          const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
          if (this.track.scrollLeft >= maxScroll) {
            this.track.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            this.scrollByItem(1);
          }
        };
        const start = () => {
          clearInterval(this.autoplayTimer);
          this.autoplayTimer = setInterval(advance, autoplaySeconds * 1000);
        };
        const stop = () => clearInterval(this.autoplayTimer);
        start();
        this.addEventListener('mouseenter', stop);
        this.addEventListener('mouseleave', start);
        this.addEventListener('focusin', stop);
        this.addEventListener('focusout', start);
      }
    }

    disconnectedCallback() {
      clearInterval(this.autoplayTimer);
      clearTimeout(this.settleTimer);
      if (this.ro) this.ro.disconnect();
      else if (this._onResize) window.removeEventListener('resize', this._onResize);
    }

    setup() {
      if (!this.wantsLoop || !this.originals.length) {
        this.refreshDots();
        this.updateButtons();
        return;
      }
      const itemW = this.rawItemWidth();
      if (itemW <= 0) return;

      const cs = getComputedStyle(this.track);
      const padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      const contentW = Math.max(0, this.track.clientWidth - padX);
      const visible = Math.max(1, Math.round(contentW / itemW));
      const shouldLoop = this.originals.length > visible;

      if (shouldLoop && !this.loopReady) this.buildClones(visible);
      else if (!shouldLoop && this.loopReady) this.teardownClones();

      if (this.loopReady) this.recenter(true);
      this.updateButtons();
    }

    buildClones(visible) {
      this.sideSets = Math.max(2, Math.ceil((visible + 1) / this.originals.length));
      const head = document.createDocumentFragment();
      const tail = document.createDocumentFragment();
      for (let s = 0; s < this.sideSets; s += 1) {
        this.originals.forEach((el) => {
          head.appendChild(this.makeClone(el));
          tail.appendChild(this.makeClone(el));
        });
      }
      this.track.insertBefore(head, this.track.firstChild);
      this.track.appendChild(tail);
      this.loopReady = true;
    }

    makeClone(el) {
      const clone = el.cloneNode(true);
      clone.classList.add('is-clone');
      clone.setAttribute('aria-hidden', 'true');

      clone.querySelectorAll('a, button, input, select, textarea').forEach((node) => {
        node.setAttribute('tabindex', '-1');
      });
      return clone;
    }

    teardownClones() {
      this.track.querySelectorAll('.is-clone').forEach((node) => node.remove());
      this.loopReady = false;
    }

    rawItemWidth() {
      const item = this.originals[0] || this.track.firstElementChild;
      if (!item) return 0;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
      return item.getBoundingClientRect().width + gap;
    }

    itemWidth() {
      return this.rawItemWidth() || this.track.clientWidth;
    }

    setWidth() {
      return this.originals.length * this.itemWidth();
    }

    jumpTo(x) {
      const previous = this.track.style.scrollBehavior;
      this.track.style.scrollBehavior = 'auto';
      this.track.scrollLeft = x;
      this.track.style.scrollBehavior = previous || '';
    }

    recenter(force) {
      if (!this.loopReady) return;
      const sw = this.setWidth();
      if (sw <= 0) return;
      const p = this.track.scrollLeft;
      const offset = ((p % sw) + sw) % sw;
      const target = this.sideSets * sw + offset;
      if (force || Math.abs(p - target) > 1) this.jumpTo(target);
    }

    onScroll() {
      if (this.loopReady) {
        const sw = this.setWidth();
        const p = this.track.scrollLeft;
        const max = this.track.scrollWidth - this.track.clientWidth;
        if (p < sw * 0.5 || p > max - sw * 0.5) {

          this.recenter();
        } else {

          clearTimeout(this.settleTimer);
          this.settleTimer = setTimeout(() => this.recenter(), 150);
        }
      }
      this.updateButtons();
    }

    scrollByItem(direction) {
      this.track.scrollBy({
        left: direction * this.itemWidth(),
        behavior: reducedMotion.matches ? 'auto' : 'smooth',
      });
    }

    updateButtons() {

      this.toggleAttribute('data-scrollable', this.track.scrollWidth - this.track.clientWidth > 2);
      if (this.prevButton && this.nextButton) {
        if (this.loopReady) {

          this.prevButton.removeAttribute('disabled');
          this.nextButton.removeAttribute('disabled');
        } else {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth - 2;
          this.prevButton.toggleAttribute('disabled', this.track.scrollLeft <= 2);
          this.nextButton.toggleAttribute('disabled', this.track.scrollLeft >= maxScroll);
        }
      }
      this.updateActiveDot();
    }

    visibleCount() {
      const itemW = this.rawItemWidth();
      if (itemW <= 0) return 1;
      const cs = getComputedStyle(this.track);
      const padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      const contentW = Math.max(0, this.track.clientWidth - padX);
      return Math.max(1, Math.round(contentW / itemW));
    }

    refreshDots() {
      if (!this.dotsHost || this.loopReady) {
        if (this.dotsHost) this.dotsHost.innerHTML = '';
        this.dotCount = 0;
        return;
      }
      const visible = this.visibleCount();
      const pages = Math.max(1, this.originals.length - visible + 1);
      if (pages === this.dotCount) {
        this.updateActiveDot();
        return;
      }
      this.dotCount = pages;
      this.dotsHost.innerHTML = '';
      if (pages <= 1) return;
      const frag = document.createDocumentFragment();
      for (let i = 0; i < pages; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.dataset.dot = i;
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Review set ${i + 1} of ${pages}`);
        frag.appendChild(dot);
      }
      this.dotsHost.appendChild(frag);
      this.updateActiveDot();
    }

    updateActiveDot() {
      if (!this.dotsHost) return;
      const dots = this.dotsHost.children;
      if (!dots.length) return;
      const itemW = this.itemWidth();
      let idx = itemW > 0 ? Math.round(this.track.scrollLeft / itemW) : 0;
      idx = Math.max(0, Math.min(dots.length - 1, idx));
      for (let i = 0; i < dots.length; i += 1) {
        if (i === idx) dots[i].setAttribute('aria-current', 'true');
        else dots[i].removeAttribute('aria-current');
      }
    }

    scrollToStop(index) {
      const itemW = this.itemWidth();
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;

      let left = index >= this.dotCount - 1 ? maxScroll : index * itemW;
      left = Math.max(0, Math.min(maxScroll, left));
      this.track.scrollTo({ left, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
    }
  }
  if (!customElements.get('ubiyam-slider')) {
    customElements.define('ubiyam-slider', UbiyamSlider);
  }

  class UbiyamProductBar extends HTMLElement {
    connectedCallback() {
      this.showAfter = Number(this.dataset.showAfter || 600);

      this.querySelectorAll('.ubiyam-product-bar__submit').forEach((btn) => {
        btn.addEventListener('click', () => {
          const form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
          if (form) {
            form.requestSubmit();
          } else {
            window.location.hash = '#MainContent';
          }
        });
      });
      this.onScroll = () => {
        this.classList.toggle('is-visible', window.scrollY > this.showAfter);
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }
  }
  if (!customElements.get('ubiyam-product-bar')) {
    customElements.define('ubiyam-product-bar', UbiyamProductBar);
  }

  class UbiyamTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => {
          const move = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
          if (!move) return;
          event.preventDefault();
          const next = (index + move + this.tabs.length) % this.tabs.length;
          this.select(next);
          this.tabs[next].focus();
        });
      });
    }
    select(index) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => {
        panel.hidden = i !== index;
      });
    }
  }
  if (!customElements.get('ubiyam-tabs')) {
    customElements.define('ubiyam-tabs', UbiyamTabs);
  }

  class UbiyamMegaSwitch extends HTMLElement {
    connectedCallback() {
      this.triggers = Array.from(this.querySelectorAll('[data-mega-trigger]'));
      this.panels = Array.from(this.querySelectorAll('[data-mega-panel]'));
      this.triggers.forEach((trigger) => {
        const show = () => this.activate(trigger.dataset.megaTrigger);
        trigger.addEventListener('mouseenter', show);
        trigger.addEventListener('focus', show);
      });
    }
    activate(index) {
      this.triggers.forEach((trigger) => {
        trigger.classList.toggle('is-active', trigger.dataset.megaTrigger === index);
      });
      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.megaPanel === index);
      });
    }
  }
  if (!customElements.get('ubiyam-mega-switch')) {
    customElements.define('ubiyam-mega-switch', UbiyamMegaSwitch);
  }

  class UbiyamSplideGallery extends HTMLElement {
    connectedCallback() {
      if (window.Splide) {
        this.mountGallery();
      } else {
        window.addEventListener('load', () => this.mountGallery(), { once: true });
      }
    }
    mountGallery() {
      if (this.mounted || !window.Splide) return;
      const mainEl = this.querySelector('.ubiyam-gallery__main');
      if (!mainEl) return;
      this.mounted = true;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const main = new Splide(mainEl, {
        type: 'slide',
        rewind: true,
        drag: true,
        noDrag: '.product__media-toggle',
        arrows: false,
        pagination: false,
        speed: reduceMotion ? 0 : 420,
        rewindSpeed: reduceMotion ? 0 : 600,
      });
      const thumbsEl = this.querySelector('.ubiyam-gallery__thumbs');
      if (thumbsEl) {
        const thumbs = new Splide(thumbsEl, {
          isNavigation: true,
          fixedWidth: 84,
          fixedHeight: 84,
          gap: '4px',
          drag: 'free',
          snap: true,
          arrows: false,
          pagination: false,
          speed: reduceMotion ? 0 : 300,
          breakpoints: {

            749: { fixedWidth: 0, fixedHeight: 0, perPage: 4 },
          },
        });
        main.sync(thumbs);
        main.mount();
        thumbs.mount();
      } else {
        main.mount();
      }
      const prevBtn = this.querySelector('[data-gallery-prev]');
      const nextBtn = this.querySelector('[data-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', () => main.go('<'));
      if (nextBtn) nextBtn.addEventListener('click', () => main.go('>'));

      const warmSlides = () => {
        this.querySelectorAll('.ubiyam-gallery__main img').forEach((img) => {
          if (img.loading === 'lazy') {
            img.loading = 'eager';
            img.fetchPriority = 'low';
          }
        });
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warmSlides, { timeout: 2500 });
      } else {
        setTimeout(warmSlides, 900);
      }
    }
  }
  if (!customElements.get('ubiyam-splide-gallery')) {
    customElements.define('ubiyam-splide-gallery', UbiyamSplideGallery);
  }

  class UbiyamRecoSlider extends HTMLElement {
    connectedCallback() {
      if (this.mounted) return;
      if (window.Splide) {
        this.mountRail();
      } else {
        window.addEventListener('load', () => this.mountRail(), { once: true });
      }
    }
    mountRail() {
      if (this.mounted || !window.Splide) return;
      const el = this.querySelector('.ubiyam-reco__splide');
      if (!el) return;
      this.mounted = true;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rail = new Splide(el, {
        type: 'slide',
        autoWidth: true,
        drag: true,
        arrows: false,
        pagination: false,
        gap: '16px',
        focus: 0,
        omitEnd: true,
        speed: reduceMotion ? 0 : 420,
        breakpoints: {
          989: { padding: { left: '14px', right: '14px' } },
        },
      });
      rail.mount();
      const prev = this.querySelector('[data-slider-prev]');
      const next = this.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', () => rail.go('<'));
      if (next) next.addEventListener('click', () => rail.go('>'));
    }
  }
  if (!customElements.get('ubiyam-reco-slider')) {
    customElements.define('ubiyam-reco-slider', UbiyamRecoSlider);
  }

  class UbiyamLightbox extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;

      if (this.parentElement && this.parentElement !== document.body) {
        document.body.appendChild(this);
      }
      this.stage = this.querySelector('[data-lightbox-stage]');
      this.img = this.querySelector('[data-lightbox-img]');
      this.img.decoding = 'async';
      this.img.fetchPriority = 'high';

      this.img.addEventListener('load', () => this.applyTransform());
      this.thumbsEl = this.querySelector('[data-lightbox-thumbs]');
      this.countEl = this.querySelector('[data-lightbox-count]');
      this.levelEl = this.querySelector('[data-lightbox-level]');
      this.closeBtn = this.querySelector('[data-lightbox-close]');
      this.thumbs = Array.from(this.querySelectorAll('[data-lightbox-thumb]'));
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.preloaded = [];
      const warmFull = () => {
        this.thumbs.forEach((t) => {
          if (!t.dataset.full) return;
          const pre = new Image();
          pre.decoding = 'async';
          pre.fetchPriority = 'low';
          pre.src = t.dataset.full;
          this.preloaded.push(pre);
        });
      };
      if ('requestIdleCallback' in window) {
        requestIdleCallback(warmFull, { timeout: 3500 });
      } else {
        setTimeout(warmFull, 1400);
      }
      this.index = 0;
      this.scale = 1;
      this.tx = 0;
      this.ty = 0;
      this.pointers = new Map();
      this.onKey = this.onKey.bind(this);
      this.onResize = () => this.applyTransform();
      this.closeBtn.addEventListener('click', () => this.hide());
      this.querySelector('[data-lightbox-prev]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-lightbox-next]').addEventListener('click', () => this.step(1));
      this.querySelectorAll('[data-lightbox-zoom]').forEach((btn) => {
        const factor = btn.dataset.lightboxZoom === 'in' ? 1.5 : 1 / 1.5;
        btn.addEventListener('click', () => this.zoomAt(0, 0, this.scale * factor, true));
      });
      this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.setActive(i)));
      this.stage.addEventListener('wheel', (e) => this.onWheel(e), { passive: false });
      this.stage.addEventListener('dblclick', (e) => {

        if (this.justOpened) return;

        if (e.target.closest('button')) return;
        this.zoomAt(e.clientX, e.clientY, this.scale > 1.01 ? 1 : 2.5);
      });
      this.stage.addEventListener('pointerdown', (e) => this.onPointerDown(e));
      this.stage.addEventListener('pointermove', (e) => this.onPointerMove(e));
      this.stage.addEventListener('pointerup', (e) => this.onPointerUp(e));
      this.stage.addEventListener('pointercancel', (e) => this.onPointerUp(e));
    }
    show(opener) {
      this.opener = opener;

      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      this.scale = 1;
      this.tx = 0;
      this.ty = 0;
      this.justOpened = true;
      window.setTimeout(() => { this.justOpened = false; }, 400);
      const mediaId = opener && opener.getAttribute('data-media-id');
      const idx = this.thumbs.findIndex((t) => t.dataset.mediaId === mediaId);
      this.setActive(idx >= 0 ? idx : 0);
      window.addEventListener('keydown', this.onKey);
      window.addEventListener('resize', this.onResize);
      if (typeof trapFocus === 'function') trapFocus(this, this.closeBtn);
    }
    hide() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      window.removeEventListener('keydown', this.onKey);
      window.removeEventListener('resize', this.onResize);
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.opener);
    }
    onKey(e) {
      if (e.code === 'Escape') this.hide();
      if (e.code === 'ArrowLeft') this.step(-1);
      if (e.code === 'ArrowRight') this.step(1);
    }
    step(dir) {
      this.setActive((this.index + dir + this.thumbs.length) % this.thumbs.length);
    }
    setActive(i) {
      if (!this.thumbs.length) return;
      this.index = i;
      const thumb = this.thumbs[i];
      this.img.src = thumb.dataset.full;
      this.img.alt = thumb.dataset.alt || '';
      this.scale = 1;
      this.tx = 0;
      this.ty = 0;
      this.applyTransform();
      this.countEl.textContent = i + 1 + ' / ' + this.thumbs.length;
      this.thumbs.forEach((t, j) => t.classList.toggle('is-active', j === i));

      if (this.thumbsEl && this.thumbsEl.scrollWidth > this.thumbsEl.clientWidth + 1) {
        thumb.scrollIntoView({
          block: 'nearest',
          inline: 'center',
          behavior: this.reduceMotion ? 'auto' : 'smooth',
        });
      }
    }
    zoomAt(cx, cy, next, fromCenter) {
      const clamped = Math.min(4, Math.max(1, next));
      const rect = this.stage.getBoundingClientRect();
      const ox = fromCenter ? 0 : cx - rect.left - rect.width / 2;
      const oy = fromCenter ? 0 : cy - rect.top - rect.height / 2;
      const ratio = clamped / this.scale;
      this.tx = ox - (ox - this.tx) * ratio;
      this.ty = oy - (oy - this.ty) * ratio;
      this.scale = clamped;
      this.applyTransform();
    }
    onWheel(e) {
      e.preventDefault();
      this.zoomAt(e.clientX, e.clientY, this.scale * (e.deltaY < 0 ? 1.16 : 1 / 1.16));
    }
    onPointerDown(e) {
      if (e.target.closest('button')) return;
      this.stage.setPointerCapture(e.pointerId);
      this.pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      this.movedDist = 0;
      this.downTarget = e.target;
    }
    onPointerMove(e) {
      const prev = this.pointers.get(e.pointerId);
      if (!prev) return;
      const cur = { x: e.clientX, y: e.clientY };
      this.pointers.set(e.pointerId, cur);
      this.movedDist += Math.abs(cur.x - prev.x) + Math.abs(cur.y - prev.y);
      if (this.pointers.size === 2) {
        let other = null;
        this.pointers.forEach((p, id) => {
          if (id !== e.pointerId) other = p;
        });
        const prevDist = Math.hypot(prev.x - other.x, prev.y - other.y);
        const newDist = Math.hypot(cur.x - other.x, cur.y - other.y);
        if (prevDist > 0) {
          const midX = (cur.x + other.x) / 2;
          const midY = (cur.y + other.y) / 2;
          this.zoomAt(midX, midY, this.scale * (newDist / prevDist));
        }
      } else if (this.scale > 1.01) {
        this.tx += cur.x - prev.x;
        this.ty += cur.y - prev.y;
        this.applyTransform();
      } else {
        this.swipeX = (this.swipeX || 0) + (cur.x - prev.x);
      }
    }
    onPointerUp(e) {
      if (!this.pointers.has(e.pointerId)) return;
      this.pointers.delete(e.pointerId);
      if (this.pointers.size === 0) {
        if (this.scale <= 1.01 && Math.abs(this.swipeX || 0) > 48) {
          this.step(this.swipeX < 0 ? 1 : -1);
        } else if (this.movedDist < 6 && this.downTarget === this.stage) {
          this.hide();
        }
        this.swipeX = 0;
      }
    }
    applyTransform() {
      const maxX = Math.max(0, (this.img.offsetWidth * this.scale - this.stage.clientWidth) / 2);
      const maxY = Math.max(0, (this.img.offsetHeight * this.scale - this.stage.clientHeight) / 2);
      this.tx = Math.min(maxX, Math.max(-maxX, this.tx));
      this.ty = Math.min(maxY, Math.max(-maxY, this.ty));
      this.img.style.transform = 'translate(' + this.tx + 'px, ' + this.ty + 'px) scale(' + this.scale + ')';
      if (this.levelEl) this.levelEl.textContent = this.scale.toFixed(2) + 'x';
      this.stage.classList.toggle('is-zoomed', this.scale > 1.01);
    }
  }
  if (!customElements.get('ubiyam-lightbox')) {
    customElements.define('ubiyam-lightbox', UbiyamLightbox);
  }

  class UbiyamPurchaseOptions extends HTMLElement {
    connectedCallback() {
      this.radios = Array.from(this.querySelectorAll('input[type="radio"][data-selling-plan]'));
      this.radios.forEach((radio) => {
        radio.addEventListener('change', () => this.apply(radio));
      });
      const checked = this.radios.find((radio) => radio.checked);
      if (checked) this.apply(checked);
    }
    apply(radio) {
      const productForm = document.querySelector(
        `#${this.dataset.formId || ''}`
      ) || document.querySelector('product-form form[data-type="add-to-cart-form"]');
      if (!productForm) return;
      let input = productForm.querySelector('input[name="selling_plan"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'selling_plan';
        productForm.appendChild(input);
      }
      input.value = radio.dataset.sellingPlan || '';
      this.querySelectorAll('.ubiyam-purchase-option').forEach((option) => {
        option.classList.toggle('is-selected', option.contains(radio));
      });
    }
  }
  if (!customElements.get('ubiyam-purchase-options')) {
    customElements.define('ubiyam-purchase-options', UbiyamPurchaseOptions);
  }

  class UbiyamAnnouncement extends HTMLElement {
    connectedCallback() {
      this.messages = Array.from(this.querySelectorAll('[data-announcement]'));
      if (this.messages.length < 2 || reducedMotion.matches) return;
      this.index = 0;
      this.delay = Number(this.dataset.rotateSpeed || 5) * 1000;
      this.timer = setInterval(() => this.next(), this.delay);
      this.addEventListener('mouseenter', () => clearInterval(this.timer));
      this.addEventListener('mouseleave', () => {
        this.timer = setInterval(() => this.next(), this.delay);
      });
    }
    next() {
      this.messages[this.index].hidden = true;
      this.index = (this.index + 1) % this.messages.length;
      this.messages[this.index].hidden = false;
    }
    disconnectedCallback() {
      clearInterval(this.timer);
    }
  }
  if (!customElements.get('ubiyam-announcement')) {
    customElements.define('ubiyam-announcement', UbiyamAnnouncement);
  }

  function ubiyamFormatMoney(cents, format) {
    const fixed = (cents / 100).toFixed(2);
    const parts = fixed.split('.');
    const dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace(/\{\{\s*amount\s*\}\}/g, dot + '.' + parts[1])
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, dot)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, comma + ',' + parts[1])
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, comma);
  }

  function ubiyamTick(el) {
    if (!el) return;
    el.classList.remove('ubiyam-qty-tick');
    void el.offsetWidth;
    el.classList.add('ubiyam-qty-tick');
  }

  function ubiyamSyncQuantityPrice(input) {
    const stepper = input.closest('quantity-input');
    if (!stepper || !stepper.dataset.section) return;
    const priceBox = document.getElementById('price-' + stepper.dataset.section);
    const price = priceBox && priceBox.querySelector('.ubiyam-price');
    if (!price || !price.dataset.unitPrice) return;
    const qty = Math.max(1, parseInt(input.value, 10) || 1);
    const format = price.dataset.moneyFormat || '${{amount}}';
    const current = price.querySelector('.ubiyam-price__current');
    if (current) current.textContent = ubiyamFormatMoney(qty * parseInt(price.dataset.unitPrice, 10), format);
    const compareCents = parseInt(price.dataset.comparePrice, 10) || 0;
    const compare = price.querySelector('.ubiyam-price__compare');
    if (compare && compareCents) {

      const nodes = Array.prototype.filter.call(compare.childNodes, (n) => n.nodeType === 3 && n.nodeValue.trim());
      if (nodes.length) nodes[nodes.length - 1].nodeValue = ubiyamFormatMoney(qty * compareCents, format);
    }

    const submit = document.getElementById('ProductSubmitButton-' + stepper.dataset.section);
    const atcPrice = submit && submit.querySelector('.ubiyam-atc-price');
    if (atcPrice) atcPrice.textContent = ubiyamFormatMoney(qty * parseInt(price.dataset.unitPrice, 10), format);
    ubiyamTick(input);
    ubiyamTick(current);
  }

  ['change', 'input'].forEach((type) => {
    document.addEventListener(type, (event) => {
      const input = event.target;
      if (input.classList && input.classList.contains('quantity__input') && input.closest('.ubiyam-pdp')) {
        ubiyamSyncQuantityPrice(input);
      }
    });
  });

  const ACCORDION_EXPAND_MS = 700;
  const ACCORDION_COLLAPSE_MS = 600;

  const ACCORDION_EASE = 'cubic-bezier(0.45, 0, 0.15, 1)';
  const accordionReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function accordionCollapsedHeight(details) {
    const summary = details.querySelector('summary');
    const style = getComputedStyle(details);
    return summary.offsetHeight + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
  }

  function animateAccordionHeight(details, from, to, duration, onFinish) {
    const animation = details.animate(
      { height: [from + 'px', to + 'px'] },
      { duration, easing: ACCORDION_EASE, fill: 'forwards' }
    );
    details.ubiyamAnimation = animation;
    animation.onfinish = () => {
      if (onFinish) onFinish();
      animation.cancel();
      details.ubiyamAnimation = null;
    };
  }

  function expandAccordion(details) {
    const startHeight = details.offsetHeight;
    if (details.ubiyamAnimation) details.ubiyamAnimation.cancel();
    details.classList.remove('is-closing');
    details.setAttribute('open', '');
    const endHeight = details.offsetHeight;
    animateAccordionHeight(details, startHeight, endHeight, ACCORDION_EXPAND_MS);
  }

  function collapseAccordion(details) {
    if (!details.hasAttribute('open')) return;
    const startHeight = details.offsetHeight;
    if (details.ubiyamAnimation) details.ubiyamAnimation.cancel();
    details.classList.add('is-closing');
    animateAccordionHeight(details, startHeight, accordionCollapsedHeight(details), ACCORDION_COLLAPSE_MS, () => {
      details.removeAttribute('open');
      details.classList.remove('is-closing');
    });
  }

  function closeAccordionInstantly(details) {
    if (details.ubiyamAnimation) details.ubiyamAnimation.cancel();
    details.ubiyamAnimation = null;
    details.classList.remove('is-closing');
    details.removeAttribute('open');
  }

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('details.ubiyam-accordion > summary');
    if (!summary) return;
    const details = summary.parentElement;
    const group = details.closest('[data-ubiyam-accordion-group]');

    if (accordionReducedMotion.matches) {

      if (group) {
        group.querySelectorAll('details[open]').forEach((other) => {
          if (other !== details) other.removeAttribute('open');
        });
      }
      return;
    }

    event.preventDefault();
    if (details.hasAttribute('open') && !details.classList.contains('is-closing')) {
      closeAccordionInstantly(details);
      return;
    }
    if (group) {
      group.querySelectorAll('details[open]').forEach((other) => {
        if (other !== details) collapseAccordion(other);
      });
    }
    expandAccordion(details);
  });
})();
